import { Outlet } from "react-router-dom";
import { Navbar, Footer } from "../components/site/Navbar";
import { Chatbot } from "../components/site/Chatbot";
import { useSite } from "../context/SiteContext";

export default function PublicLayout() {
  const { site } = useSite();
  return (
    <div className="min-h-screen flex flex-col" data-testid="public-layout">
      <Navbar />
      <main className="flex-1">{site ? <Outlet /> : <div className="h-screen grid place-items-center text-[#00d9ff] font-cond uppercase tracking-widest">Loading...</div>}</main>
      <Footer />
      <Chatbot />
    </div>
  );
}

export function PageHero({ eyebrow, white, blue, desc }) {
  return (
    <section className="relative pt-32 pb-12 px-5 lg:px-8 bg-[radial-gradient(ellipse_at_top,rgba(0,100,255,.25),transparent_65%)] border-b border-[#007bff]/15">
      <div className="max-w-6xl mx-auto">
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl mt-2"><span className="text-metal">{white}</span> <span className="text-electric">{blue}</span></h1>
        {desc && <p className="mt-4 text-slate-300 max-w-2xl text-base md:text-lg">{desc}</p>}
      </div>
    </section>
  );
}
